import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router/";
import store from "./store";
import "./registerServiceWorker";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "font-awesome/css/font-awesome.css";
import Vuetify from "vuetify";
import es from "vuetify/es5/locale/es";
import axios from "axios";
import * as VueGoogleMaps from "vue2-google-maps";
import {
    apiHost
} from "./config";
import moment from "moment";

import userService from "@/services/usuarioService";
import corteCajaService from "@/services/corteCajaService";

var timer;

Vue.config.productionTip = false;
axios.defaults.baseURL = apiHost;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyCgN0Rtp2aD2OiGd8IBsXvMXIw_nHeGuAU",
        libraries: "places", // This is required if you use the Autocomplete plugin
    },
});

Vue.use(Vuetify, {
    lang: {
        locales: {
            es
        },
        current: "es",
    },
});
moment.locale("es");

//Funciones globales
Vue.mixin({
    methods: {
        getCurrentUser() {
            let self = this;
            userService
                .getCurrent()
                .then((result) => {
                    this.$store.state.currentUser = result;
                    localStorage.setItem("user_logged", result);
                    this.agregarCorteCaja();
                })
                .catch((e) => {
                    console.log("falla get current user");
                    console.log(e);
                    self.operationFailed(e);
                });
        },
        zeroFill(number, width) {
            width -= number.toString().length;
            if (width > 0) {
                return (
                    new Array(width + (/\./.test(number) ? 2 : 1)).join("0") + number
                );
            }
            return number + ""; // always return a string
        },
        roundNumber(num, scale) {
            if (!("" + num).includes("e")) {
                return +(Math.round(num + "e+" + scale) + "e-" + scale);
            } else {
                var arr = ("" + num).split("e");
                var sig = "";
                if (+arr[1] + scale > 0) {
                    sig = "+";
                }
                return +(
                    Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) +
                    "e-" +
                    scale
                );
            }
        },
        formatMoney(number) {
            return number.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
        },
        getDate() {
            return moment(new Date()).format("YYYY-MM-DD");
        },
        formatDate(data) {
            return moment(data).format("YYYY-MM-DD");
        },
        formatDateTime(data) {
            return moment(data).format("YYYY-MM-DD HH:mm");
        },
        onlyNumbers(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }
            return true;
        },
        // showMessageBox(message, messageType) {
        //   let iconMessage = "<span class='text-primary text-bold float-left mr-10'><i class='fas fa-info-circle fa-3x'></i>"

        //   if (messageType === "error") {
        //     iconMessage = "<span class='text-danger text-bold float-left mr-10'><i class='fas fa-times-circle fa-3x'></i></span>"
        //   }
        //   if (messageType === "warning") {
        //     iconMessage = "<span class='text-warning text-bold float-left mr-10'><i class='fas fa-exclamation-triangle fa-3x'></i></span>"
        //   }
        //   if (messageType === "success") {
        //     iconMessage = "<span class='text-success text-bold float-left mr-10'><i class='fas fa-check-circle fa-3x'></i></span>"
        //   }

        //   var box = bootbox.alert({
        //     message: iconMessage + " <h5 class='pt-10'>" + message + "</h5>",
        //     backdrop: true
        //   });

        //   box.css({
        //     'top': '50%',
        //     'margin-top': function () {
        //       return -(box.height() / 2);
        //     }
        //   });
        // },
        operationStart() {
            (this.$store.state.operationInProgress = true),
            (this.$store.state.operationSuccess = false);
            this.$store.state.operationFailed = false;
        },
        operationSuccess() {
            (this.$store.state.operationInProgress = false),
            (this.$store.state.operationSuccess = true);
            this.$store.state.operationFailed = false;
        },
        operationFailed(e) {
            (this.$store.state.operationInProgress = false),
            (this.$store.state.operationSuccess = false);
            this.$store.state.operationFailed = true;
            if (e.response.status === 405) {
                this.$store.state.errorMessage =
                    "La acción no está permitida o no existe, contacta al administrador";
            }
            if (e.response.status === 403) {
                console.log("Inicio sesión");
                window.getApp.$emit("APP_LOGOUT");
                this.$store.state.errorMessage = e.response.data.message;
            }
            if (e.response.status === 400) {
                this.$store.state.errorMessage = e.response.data.message;
            }
            if (e.response.status === 500) {
                this.$store.state.errorMessage = e.response.data.exceptionMessage;
            }
        },
        codeFailed(message) {
            (this.$store.state.operationInProgress = false),
            (this.$store.state.operationSuccess = false);
            this.$store.state.operationFailed = true;
            this.$store.state.errorMessage = message;
        },
        operationReset() {
            this.$store.state.operationSuccess = false;
            this.$store.state.operationFailed = false;
            (this.$store.state.operationInProgress = false),
            (this.$store.state.loading = false);
        },
        toUpper(e) {
            if (typeof e !== "undefined") {
                return e.toUpperCase();
            }
        },
        firstLetter(e) {
            if (typeof e !== "undefined") {
                return e.substring(0, 1).toUpperCase();
            }
        },
        agregarCorteCaja() {
            corteCajaService.addCorteCaja().then((result) => {
                this.verificarCorteCaja();
            });
        },
        verificarCorteCaja() {
            let self = this;
            let current_user = this.$store.state.currentUser;
            let sucursalesUsuario = current_user.sucursales;

            if (sucursalesUsuario.length == 1) {
                corteCajaService.verificarCaja(sucursalesUsuario[0].sucursalId)
                    .then((result) => {
                        if (timer !== undefined) {
                            clearTimeout(timer);
                        }

                        if (Number(result.montoEnCuenta) >= Number(result.montoCorteLimite)) {
                            console.log("ALERTA LANZADA!!!!!")
                            let milisegundosProxVerificacion = this.minutosAMilisegundos(result.tiempoProximaVerificacionMinutos);
                            timer = setTimeout(self.verificarCorteCaja, milisegundosProxVerificacion);

                            self.$store.state.notificacionCorteCaja = true;
                            self.$store.state.realizarCorteCaja = true;
                        } else {
                            self.$store.state.notificacionCorteCaja = false;
                            self.$store.state.realizarCorteCaja = false;
                        }

                    });
            }
        },
        minutosAMilisegundos(minutos) {
            if (minutos > 0) {
                return minutos * 60000;
            }
            //Por default 45 minutos
            return 2700000;
        }
    },
});

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");